import { render, staticRenderFns } from "./RectangleInfo.vue?vue&type=template&id=53cc017c&"
import script from "./RectangleInfo.vue?vue&type=script&lang=js&"
export * from "./RectangleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports